<template>
  <div class="addressMana addressMana--a">
    <loading v-if="loading"></loading>
    <AddressList
      v-model="chosenAddressId"
      :list="list"
      :disabled-list="disabledList"
      disabled-text=""
      default-tag-text="默认"
      @add="onAdd"
      @edit="onEdit"
    />
  </div>
</template>

<script>
import { AddressList, Toast } from "vant";
import { initOpenid } from "@/utils/getOpenid";
import { addressList } from "@/api/officialAccount/index.js";
export default {
  components: { AddressList },
  data() {
    return {
      chosenAddressId: "1",
      list: [],
      loading: true,
      disabledList: [], // 距离太远不可送
    };
  },
  created() {
    console.log(this.$route.params, "头部参数");
    this.chosenAddressId = this.$store.state.offici.address.id;
    console.log(this.chosenAddressId);
    if (this.$route.params.message) Toast(this.$route.params.message);
    if (
      process.env.NODE_ENV === "development" &&
      !localStorage.getItem("openId")
    ) {
      localStorage.setItem("openId", "dev_test_openid");
    }
    if (!localStorage.getItem("openId")) {
      initOpenid(this.addressListhanlde);
    } else {
      this.addressListhanlde();
    }
  },
  mounted() {
    var box = document.getElementsByClassName("van-address-list__bottom");
    var box1 = document.getElementsByClassName("van-button__text");
    box1.innerText = "新建收货地址";
    console.log(box);
    var div = document.createElement("div");
    div.innerText = "确定";
    div.style.width = "100%";
    div.style.height = "40px";
    div.style.margin = "20px 0";
    div.style.background = "#fff";
    div.style.borderRadius = "400px";
    div.style.textAlign = "center";
    div.style.lineHeight = "40px";
    div.style.fontSize = "14px";
    div.onclick = () => {
      this.$router.push({ name: "appraise" });
    };
    box[0].appendChild(div);
  },
  beforeDestroy() {
    console.log(this.chosenAddressId, this.list);
    this.list.map((item) => {
      if (this.chosenAddressId == item.id) {
        this.$store.commit("offici/setAddress", item);
      }
    });
  },
  methods: {
    async addressListhanlde() {
      this.openId = localStorage.getItem("openId");
      const { data, code } = await addressList({
        openid: this.openId,
      });
      if (code !== "0000000") {
        this.loading = false;
        return;
      }
      this.list = [];
      data.map((item) => {
        this.list.push({
          id: item.id,
          name: item.name,
          tel: item.phone,
          address:
            item.province +
            "," +
            item.city +
            "," +
            item.area +
            "," +
            item.detail,
          isDefault: item.type ? true : false,
          province: item.province,
          city: item.city,
          detail: item.detail,
          areaCode: item.code,
          county: item.area,
        });
        if (!this.chosenAddressId && item.type) this.chosenAddressId = item.id;
      });
      this.loading = false;
      console.log(this.chosenAddressId);
    },
    onAdd() {
      this.$router.push({ path: "/addressEdit" });
    },
    onEdit(item, index) {
      console.log("编辑地址:" + index, item);
      const address = {
        id: item.id,
        name: item.name,
        tel: item.tel,
        isDefault: item.isDefault,
        province: item.province,
        city: item.city,
        addressDetail: item.detail,
        areaCode: item.areaCode,
        county: item.county,
      };
      this.$router.push({
        path: "/addressEdit",
        query: { address: JSON.stringify(address) },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.addressMana {
  height: 100vh;
  overflow-y: auto;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
/deep/.van-address-list {
  overflow-y: auto;
  padding: 12px 12px 112px;
}
/deep/.van-address-list__bottom {
  background: #f1f1f2;
}
/deep/.van-button--danger {
  background-color: #60bb46;
  border: 1px solid #60bb46;
}
/deep/.van-tag--danger {
  background-color: #60bb46;
}
/deep/.van-address-item .van-radio__icon--checked .van-icon {
  background-color: #60bb46;
  border-color: #60bb46;
}
</style>

<!--
  改版方案 A（2026-09-22）：分组列表。只改样式和布局，文字不动。
  回退：去掉模板根节点上的 addressMana--a。
-->
<style lang="less" scoped>
@a-bg: #f2f2f7;
@a-card: #fff;
@a-line: #e9e9ee;
@a-ink: #1c1c1e;
@a-sub: #8a8a8e;
@a-green: #60bb46;
@a-green-text: #3f9a2e;
@a-radius: 12px;

.addressMana--a {
  background: @a-bg;
  color: @a-ink;

  /deep/ .van-address-list {
    padding: 14px 16px 150px;
  }
  // 每个地址一张圆角卡片
  /deep/ .van-address-item {
    margin-bottom: 12px;
    padding: 14px 16px;
    border-radius: @a-radius;
    background: @a-card;
  }
  /deep/ .van-address-item__name {
    font-size: 16px;
    font-weight: 600;
    color: @a-ink;
  }
  /deep/ .van-address-item__address {
    margin-top: 4px;
    font-size: 13px;
    line-height: 1.5;
    color: @a-sub;
  }
  /deep/ .van-address-item__edit {
    color: @a-sub;
  }
  /deep/ .van-tag--danger {
    border-radius: 4px;
    background-color: @a-green;
  }
  // 底部按钮栏：半透明毛玻璃
  /deep/ .van-address-list__bottom {
    padding: 10px 16px calc(10px + env(safe-area-inset-bottom, 0px));
    background: rgba(248, 248, 250, 0.92);
    backdrop-filter: saturate(180%) blur(16px);
    -webkit-backdrop-filter: saturate(180%) blur(16px);
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }
  /deep/ .van-address-list__add {
    height: 46px;
    margin: 0;
    border-radius: @a-radius;
    font-size: 16px;
    font-weight: 600;
  }
  // 页面脚本插入的「确定」按钮（带行内样式，需 !important）
  /deep/ .van-address-list__bottom > div {
    height: 46px !important;
    margin: 8px 0 0 !important;
    border-radius: @a-radius !important;
    background: @a-card !important;
    line-height: 46px !important;
    font-size: 16px !important;
    font-weight: 600;
    color: @a-green-text;
  }
}
</style>
